import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import swal from 'sweetalert2';
import Moment from 'moment';
import * as microsoftTeams from '@microsoft/teams-js';
import { getRootUrl } from 'helpers/url';
import { isIframe } from 'helpers/teams';
import { isUserTeacher } from 'helpers/user';
import { getEducationGroups, getSectionByGraphId, getSection, setActiveSection } from 'actions/sections';
import { setPageTitle, setPageActions } from 'actions/header';
import { clearAssignmentsFromStore, getHaldorAssignments, getMicrosoftEducationAssignments, setAssignmentServices, getAssignmentStatus, setMyAssignmentsActiveGroup, updateBulkAssignmentObject } from 'actions/assignments';
import AssignmentForm from 'containers/Forms/AssignmentForm/AssignmentForm';
import MultipleAssignmentForm from 'containers/Forms/AssignmentForm/MultipleAssignmentForm';
import Expandable from 'UI/Elements/Expandable';
import { CardsContainer } from 'components/Cards/Card';
import LoadingCards from 'components/Cards/LoadingCard';
import AssignmentCard from 'components/Presentation/Cards/AssignmentCard';
import SectionTitle from 'components/Presentation/SectionTitle';
import SectionForm from 'containers/Forms/SectionForm';
import Modal from 'containers/Modals/Modal';
import { Icon, TooltipMenu, Button } from '@haldor/ui';
import moment from 'moment';

var MyAssignments = /*#__PURE__*/function (_Component) {
  _inherits(MyAssignments, _Component);

  var _super = _createSuper(MyAssignments);

  function MyAssignments(props) {
    var _this;

    _classCallCheck(this, MyAssignments);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.props.setAssignmentServices(_this.services);

      _this.initComponent();
    });

    _defineProperty(_assertThisInitialized(_this), "initComponent", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var that, promises;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              that = _assertThisInitialized(_this);

              if (!isIframe()) {
                _context.next = 5;
                break;
              }

              microsoftTeams.app.getContext().then(function (context) {
                var promises = [];

                if (context.team) {
                  if (_this.services.haldor) {
                    promises.push(_this.props.getHaldorAssignments(context.team.groupId));
                  } else if (_this.services.microsoft) {
                    promises.push(_this.props.getMicrosoftEducationAssignments(context.team.groupId));
                  }
                } else {
                  if (_this.services.haldor) {
                    promises.push(_this.props.getHaldorAssignments());
                  } else if (_this.services.microsoft) {
                    promises.push(_this.props.getMicrosoftEducationAssignments());
                  }
                }

                Promise.race(promises).then(function () {
                  that.setState({
                    loading: false
                  });

                  _this.getData(_this.props.sections);
                });
              });
              _context.next = 13;
              break;

            case 5:
              promises = [];

              if (_this.props.groupid != null) {
                _this.props.clearAssignmentsFromStore();

                _this.props.setMyAssignmentsActiveGroup(_this.props.groupid);

                if (_this.props.activeSection.id == _this.props.groupid) {
                  if (_this.services.haldor) {
                    promises.push(_this.props.getHaldorAssignments(_this.props.activeSection.graphId));
                  } else if (_this.services.microsoft) {
                    promises.push(_this.props.getMicrosoftEducationAssignments(_this.props.activeSection.graphId));
                  }
                }
              }

              if (!(_this.props.groupid == null && _this.props.activeGroupForSection != null)) {
                _context.next = 11;
                break;
              }

              _this.props.setMyAssignmentsActiveGroup(null);

              _context.next = 11;
              return _this.props.clearAssignmentsFromStore();

            case 11:
              if ((_this.props.assignments == null || _this.props.assignments.length == 0 || _this.props.haldorAssignmentsFetchedUTC != null && moment().subtract(5, 'minute').isSameOrAfter(moment(_this.props.haldorAssignmentsFetchedUTC)) || _this.props.teamsAssignmentsFetchedUTC != null && moment().subtract(5, 'minute').isSameOrAfter(moment(_this.props.teamsAssignmentsFetchedUTC))) && _this.props.groupid == null) {
                if (_this.services.haldor) {
                  promises.push(_this.props.getHaldorAssignments());
                } else if (_this.services.microsoft) {
                  promises.push(_this.props.getMicrosoftEducationAssignments());
                }
              }

              if (promises.length > 0) {
                Promise.race(promises).then(function () {
                  _this.setState({
                    loading: false
                  });

                  _this.getData(_this.props.sections);
                });
              } else {
                _this.setState({
                  loading: false
                });

                _this.getData(_this.props.sections);
              }

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      if (_this.timer != null) {
        clearTimeout(_this.timer);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleGroupDisplay", function (groupName) {
      if ((groupName === null || groupName === void 0 ? void 0 : groupName.length) > 0) {
        _this.setState({
          groupSelected: groupName
        });
      } else {
        _this.setState({
          groupSelected: ''
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
      var list = [].concat(_toConsumableArray(nextProps.current), _toConsumableArray(nextProps.overdue));

      if (list.length > 0) {
        var creatingAssignment = list.find(function (assignment) {
          return assignment.created == '0001-01-01T00:00:00' && Moment.utc(assignment.edited).isSame(Moment.utc(), 'hour');
        });

        if (creatingAssignment != null && _this.timer == null) {
          _this.timer = setTimeout(_this.getAssignmentStatuses, 10000);
        }
      }

      if (_this.props.sections.length == 0 && nextProps.sections.length > 0) {
        _this.getData(nextProps.sections);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getAssignmentStatuses", function () {
      clearTimeout(_this.timer);
      _this.timer = null;
      var promises = [];
      var list = [].concat(_toConsumableArray(_this.props.current), _toConsumableArray(_this.props.overdue));
      list.forEach(function (assignment) {
        if (assignment.created != '0001-01-01T00:00:00' || assignment.created == null) {
          return false;
        }

        if (!Moment.utc(assignment.edited).isSame(Moment.utc(), 'hour')) {
          return false;
        }

        promises.push(_this.props.getAssignmentStatus(assignment.id));
      });
      Promise.all(promises).then(function () {
        var list = [].concat(_toConsumableArray(_this.props.current), _toConsumableArray(_this.props.overdue));
        var creatingAssignment = list.find(function (assignment) {
          return assignment.created == '0001-01-01T00:00:00' && Moment.utc(assignment.edited).isSame(Moment.utc(), 'hour');
        });

        if (creatingAssignment != null) {
          _this.timer = setTimeout(_this.getAssignmentStatuses, 10000);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getData", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(sections) {
        var isFrame, section, context, _section, _section2, actions, isTeacher;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                isFrame = isIframe();

                if (!(isFrame && getRootUrl() != '/')) {
                  _context2.next = 28;
                  break;
                }

                if (!(_this.props.groupid != null)) {
                  _context2.next = 8;
                  break;
                }

                section = sections.find(function (section) {
                  return section.id == _this.props.groupid;
                });
                _context2.next = 6;
                return _this.setState({
                  loadingGroups: false,
                  sectionId: _this.props.groupid,
                  graphId: section.graphId,
                  missingWorkspace: section.classroomUrl == null || section.classroomUrl == ''
                });

              case 6:
                _context2.next = 26;
                break;

              case 8:
                _context2.next = 10;
                return microsoftTeams.app.getContext();

              case 10:
                context = _context2.sent;

                if (!context.team) {
                  _context2.next = 24;
                  break;
                }

                _section = sections.find(function (section) {
                  return section.graphId == context.team.groupId;
                });

                if (!(_section != null)) {
                  _context2.next = 20;
                  break;
                }

                _context2.next = 16;
                return _this.props.getSection(_section.id);

              case 16:
                _context2.next = 18;
                return _this.setState({
                  sectionId: _section.id,
                  noSectionFound: false,
                  graphId: context.team.groupId,
                  loadingGroups: false,
                  missingWorkspace: _section.classroomUrl == null || _section.classroomUrl == ''
                });

              case 18:
                _context2.next = 22;
                break;

              case 20:
                _context2.next = 22;
                return _this.setState({
                  noSectionFound: true,
                  teamsContext: context,
                  loadingGroups: false
                });

              case 22:
                _context2.next = 26;
                break;

              case 24:
                _context2.next = 26;
                return _this.setState({
                  noSectionFound: false,
                  loadingGroups: false
                });

              case 26:
                _context2.next = 42;
                break;

              case 28:
                if (!(_this.props.groupid != null)) {
                  _context2.next = 40;
                  break;
                }

                _section2 = sections.find(function (section) {
                  return section.id == _this.props.groupid;
                });

                if (!(_section2 != null)) {
                  _context2.next = 35;
                  break;
                }

                _context2.next = 33;
                return _this.setState({
                  loadingGroups: false,
                  sectionId: _this.props.groupid,
                  graphId: _section2.graphId,
                  missingWorkspace: _section2.classroomUrl == null || _section2.classroomUrl == ''
                });

              case 33:
                _context2.next = 38;
                break;

              case 35:
                if (!(_this.props.groupid == _this.props.activeSection.id)) {
                  _context2.next = 38;
                  break;
                }

                _context2.next = 38;
                return _this.setState({
                  loadingGroups: false,
                  sectionId: _this.props.groupid,
                  graphId: _this.props.activeSection.graphId
                });

              case 38:
                _context2.next = 42;
                break;

              case 40:
                _context2.next = 42;
                return _this.setState({
                  loadingGroups: false
                });

              case 42:
                if (_this.services.haldor) {
                  _context2.next = 44;
                  break;
                }

                return _context2.abrupt("return", null);

              case 44:
                if (!_this.props.disableCreate) {
                  _context2.next = 46;
                  break;
                }

                return _context2.abrupt("return", null);

              case 46:
                actions = [];
                isTeacher = isUserTeacher(_this.props.currentUser);

                if (isTeacher) {
                  if (getRootUrl() == '/' || getRootUrl() == '/assignments-tab/') {
                    actions.push({
                      type: 'button',
                      value: _this.props.translate('task-create-button'),
                      onClick: _this.toggleMultipleAssignmentForm,
                      buttonType: 'primary',
                      icon: 'plus'
                    });
                  }

                  actions.push({
                    type: 'button',
                    value: _this.props.translate('create-group-assignment'),
                    onClick: _this.toggleSingleAssignmentForm,
                    buttonType: 'primary',
                    icon: 'plus'
                  });

                  if (getRootUrl() == '/assignments-tab/') {
                    actions.push({
                      type: 'icon',
                      onClick: _this.toggleGroupSettings,
                      icon: 'cog_bw'
                    });
                  }
                }

                if (_this.props.groupid == null && _this.state.sectionId == null && !_this.props.overview) {
                  _this.props.setPageTitle(_this.props.translate('tasks-header-overview'));

                  _this.props.setPageActions(actions);
                }

              case 50:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "DisplayNoAssignments", function () {
      return /*#__PURE__*/React.createElement("div", {
        className: "color--meta text--center weight--bold"
      }, _this.props.translate('no-assignments-results'));
    });

    _defineProperty(_assertThisInitialized(_this), "openModal", function () {
      _this.setState({
        modalIsOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleGroupSettings", function (shouldReload) {
      _this.setState({
        groupForm: !_this.state.groupForm
      });

      if (shouldReload == true) {
        microsoftTeams.app.getContext().then(function (context) {
          _this.props.getSectionByGraphId(context.team.groupId);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "closeModal", function () {
      swal.fire({
        title: _this.props.translate('are-you-sure'),
        text: _this.props.translate('close-form-prompt'),
        showCancelButton: true,
        cancelButtonText: _this.props.translate('No'),
        confirmButtonText: _this.props.translate('Yes')
      }).then(function (result) {
        if (result.value != null) {
          _this.setState({
            modalIsOpen: false
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "enableOverlayWarningClose", function (enable) {
      _this.setState({
        enableOverlayWarning: enable
      });
    });

    _defineProperty(_assertThisInitialized(_this), "overlayWarningPromptAgree", function () {
      _this.setState({
        modalIsOpen: false,
        overlayWarningPrompt: false,
        enableOverlayWarning: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "overlayWarningPromptClose", function () {
      _this.setState({
        overlayWarningPrompt: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "teamsTabCloseForm", function () {
      _this.setState({
        noSectionFound: false
      }, function () {
        window.location = window.location.href;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "CreateButton", function () {
      if (!_this.services.haldor) {
        return null;
      }

      if (_this.props.disableCreate) {
        return null;
      } // Do not show button until loading is complete


      if (_this.state.loading) {
        return null;
      }

      var isTeacher = isUserTeacher(_this.props.currentUser);

      if (isTeacher) {
        if (_this.state.noSectionFound) {
          return null;
        }

        if (_this.state.missingWorkspace) {
          return /*#__PURE__*/React.createElement("div", {
            className: "create-container",
            style: {
              display: 'inline-block'
            }
          }, /*#__PURE__*/React.createElement(Button, {
            type: "secondary",
            onClick: _this.showMissingWorkspaceNotice
          }, /*#__PURE__*/React.createElement(Icon, {
            name: "Plus"
          }), " ", _this.props.translate('Create')));
        }

        return /*#__PURE__*/React.createElement("div", {
          className: "create-container",
          style: {
            display: 'inline-block'
          }
        }, /*#__PURE__*/React.createElement(TooltipMenu, {
          trigger: /*#__PURE__*/React.createElement(Button, {
            type: "secondary"
          }, /*#__PURE__*/React.createElement(Icon, {
            name: "Plus"
          }), " ", _this.props.translate('Create'))
        }, /*#__PURE__*/React.createElement(TooltipMenu.Item, {
          onClick: _this.toggleSingleAssignmentForm
        }, _this.props.translate('create-group-assignment')), /*#__PURE__*/React.createElement(TooltipMenu.Item, {
          onClick: _this.toggleMultipleAssignmentForm
        }, _this.props.translate('task-create-button'))));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "showMissingWorkspaceNotice", function () {
      var text = _this.props.translate('A configuration problem has occurred with one of your groups. This means that the group is missing a workspace in Sharepoint and no assignments or plans can be created.');

      text += ' ' + _this.props.translate('Please wait and try again later. If the problem persists, please contact your school for support.');
      swal.fire({
        title: _this.props.translate('Workspace missing'),
        text: text,
        showCancelButton: false,
        confirmButtonText: _this.props.translate('Ok')
      }).then(function (result) {
        if (result.value != null) {
          _this.setState({
            modalIsOpen: false
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleSingleAssignmentForm", function () {
      _this.setState({
        singleAssignmentFormModal: !_this.state.singleAssignmentFormModal
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleMultipleAssignmentForm", function (value) {
      if (window.location.pathname.indexOf('groups') == -1 && !isIframe()) {
        _this.props.setActiveSection(null);
      }

      if (value && _this.props.createdAssignments != null && _this.props.createdAssignments.length > 0) {
        _this.props.createdAssignments.forEach(function (a) {
          _this.props.updateBulkAssignmentObject(a.id);
        });
      }

      _this.setState({
        multipleAssignmentFormModal: !_this.state.multipleAssignmentFormModal,
        groupSelected: ''
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderContent", function () {
      var isTeacher = isUserTeacher(_this.props.currentUser);
      var isFrame = isIframe();

      if (_this.state.noSectionFound && isTeacher) {
        return /*#__PURE__*/React.createElement(SectionForm, {
          editView: false,
          teamsContext: _this.state.teamsContext,
          teamsTabCloseForm: _this.teamsTabCloseForm,
          tab: "assignments",
          onboarding: true
        });
      }

      if (_this.state.loading || _this.state.loadingGroups) {
        return /*#__PURE__*/React.createElement(LoadingCards, {
          count: 3
        });
      }

      var count = 0;

      if (_this.props.assignments != null) {
        count += _this.props.assignments.length;
      }

      if (_this.props.teamsAssignments != null) {
        count += _this.props.teamsAssignments.length;
      }

      if (count == 0) {
        return _this.DisplayNoAssignments();
      }

      var sectionId = null;

      if (_this.props.groupid != null && !isFrame) {
        sectionId = _this.props.groupid;
      } else if (isFrame && _this.state.sectionId != null) {
        sectionId = _this.state.sectionId;
      }

      return /*#__PURE__*/React.createElement("div", null, _this.renderDrafts(sectionId), _this.renderOverdue(sectionId), _this.renderCurrent(sectionId), _this.renderUpcoming(sectionId), _this.renderSubmitted(sectionId), _this.renderClosed(sectionId));
    });

    _defineProperty(_assertThisInitialized(_this), "renderCurrent", function (sectionId) {
      var limit = 99999;

      if (_this.props.limit != null) {
        limit = _this.props.limit;
      }

      var list = _toConsumableArray(_this.props.current);

      if (sectionId != null) {
        list = list.filter(function (t) {
          if (t.id == parseInt(t.id, 10)) {
            return t.sectionId == sectionId;
          } else {
            return t.classId == _this.state.graphId;
          }
        });
      }

      if (list.length == 0) {
        return null;
      }

      return /*#__PURE__*/React.createElement(Expandable, {
        title: _this.props.translate('current-list-title'),
        open: _this.state.currentOpen,
        overrideOpen: true,
        ignorePropsUpdate: true
      }, /*#__PURE__*/React.createElement(CardsContainer, null, list.map(function (assignment, index) {
        if (index < limit) {
          return _this.renderTask(assignment);
        }
      })), _this.showAllLink());
    });

    _this.state = {
      loading: true,
      loadingGroups: true,
      lists: [],
      modalIsOpen: false,
      tasks: null,
      graphId: null,
      enableOverlayWarning: false,
      overlayWarningPrompt: false,
      sectionId: null,
      noSectionFound: false,
      teamsContext: null,
      multipleAssignmentFormModal: false,
      singleAssignmentFormModal: false,
      missingWorkspace: false,
      draftOpen: true,
      currentOpen: true,
      overDueOpen: false,
      upcomingOpen: false,
      submittedOpen: false,
      closedOpen: false,
      groupForm: false,
      groupSelected: ''
    };
    _this.services = {
      microsoft: props.services.microsoft,
      haldor: props.services.haldor
    };
    _this.timer = null;
    _this.toggleMultipleAssignmentForm = _this.toggleMultipleAssignmentForm.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MyAssignments, [{
    key: "renderTask",
    value: function renderTask(assignment) {
      var isTeacher = isUserTeacher(this.props.currentUser);
      return /*#__PURE__*/React.createElement(AssignmentCard, {
        key: assignment.id,
        assignment: assignment,
        isTeacher: isTeacher
      });
    }
  }, {
    key: "renderDrafts",
    value: function renderDrafts(sectionId) {
      var _this2 = this;

      var isTeacher = isUserTeacher(this.props.currentUser);

      if (!isTeacher) {
        return null;
      }

      var limit = 99999;

      if (this.props.limit != null) {
        limit = this.props.limit;
      }

      var list = this.props.drafts;

      if (sectionId != null) {
        list = list.filter(function (t) {
          if (t.id == parseInt(t.id, 10)) {
            return t.sectionId == sectionId;
          } else {
            return t.classId == _this2.state.graphId;
          }
        });
      }

      if (list.length == 0) {
        return null;
      }

      return /*#__PURE__*/React.createElement(Expandable, {
        title: this.props.translate('draft-list-title'),
        open: this.state.draftOpen,
        overrideOpen: true,
        ignorePropsUpdate: true
      }, /*#__PURE__*/React.createElement(CardsContainer, null, list.map(function (assignment, index) {
        if (index < limit) {
          return _this2.renderTask(assignment);
        }
      })), this.showAllLink());
    }
  }, {
    key: "renderOverdue",
    value: function renderOverdue(sectionId) {
      var _this3 = this;

      var limit = 99999;

      if (this.props.limit != null) {
        limit = this.props.limit;
      }

      var list = this.props.overdue;

      if (sectionId != null) {
        list = list.filter(function (t) {
          if (t.id == parseInt(t.id, 10)) {
            return t.sectionId == sectionId;
          } else {
            return t.classId == _this3.state.graphId;
          }
        });
      }

      if (list.length == 0) {
        return null;
      }

      return /*#__PURE__*/React.createElement(Expandable, {
        title: this.props.translate('overdue-list-title'),
        open: this.state.overDueOpen,
        overrideOpen: true,
        ignorePropsUpdate: true
      }, /*#__PURE__*/React.createElement(CardsContainer, null, list.map(function (assignment, index) {
        if (index < limit) {
          return _this3.renderTask(assignment);
        }
      })), this.showAllLink());
    }
  }, {
    key: "renderUpcoming",
    value: function renderUpcoming(sectionId) {
      var _this4 = this;

      var limit = 99999;

      if (this.props.limit != null) {
        limit = this.props.limit;
      }

      var list = this.props.upcoming;

      if (sectionId != null) {
        list = list.filter(function (t) {
          if (t.id == parseInt(t.id, 10)) {
            return t.sectionId == sectionId;
          } else {
            return t.classId == _this4.state.graphId;
          }
        });
      }

      if (list.length == 0) {
        return null;
      }

      return /*#__PURE__*/React.createElement(Expandable, {
        title: this.props.translate('upcoming-list-title'),
        open: this.state.upcomingOpen,
        overrideOpen: true,
        ignorePropsUpdate: true
      }, /*#__PURE__*/React.createElement(CardsContainer, null, list.map(function (assignment, index) {
        if (index < limit) {
          return _this4.renderTask(assignment);
        }
      })), this.showAllLink());
    }
  }, {
    key: "renderSubmitted",
    value: function renderSubmitted(sectionId) {
      var _this5 = this;

      var isTeacher = isUserTeacher(this.props.currentUser);

      if (isTeacher || this.props.limit != null) {
        return null;
      }

      var list = this.props.submitted;

      if (sectionId != null) {
        list = list.filter(function (t) {
          if (t.id == parseInt(t.id, 10)) {
            return t.sectionId == sectionId;
          } else {
            return t.classId == _this5.state.graphId;
          }
        });
      }

      if (list.length == 0) {
        return null;
      }

      return /*#__PURE__*/React.createElement(Expandable, {
        title: this.props.translate('submitted-list-title'),
        open: this.state.submittedOpen,
        overrideOpen: true,
        ignorePropsUpdate: true
      }, /*#__PURE__*/React.createElement(CardsContainer, null, list.map(function (assignment) {
        return _this5.renderTask(assignment);
      })), this.showAllLink());
    }
  }, {
    key: "renderClosed",
    value: function renderClosed(sectionId) {
      var _this6 = this;

      var isTeacher = isUserTeacher(this.props.currentUser);

      if (!isTeacher || this.props.limit != null) {
        return null;
      }

      var list = this.props.closed;

      if (sectionId != null) {
        list = list.filter(function (t) {
          if (t.id == parseInt(t.id, 10)) {
            return t.sectionId == sectionId;
          } else {
            return t.classId == _this6.state.graphId;
          }
        });
      }

      if (list.length == 0) {
        return null;
      }

      return /*#__PURE__*/React.createElement(Expandable, {
        title: this.props.translate('Hidden'),
        open: this.state.closedOpen,
        overrideOpen: true,
        ignorePropsUpdate: true
      }, /*#__PURE__*/React.createElement(CardsContainer, null, list.map(function (assignment) {
        return _this6.renderTask(assignment);
      })), this.showAllLink());
    }
  }, {
    key: "showAllLink",
    value: function showAllLink() {
      if (this.props.limit == null) {
        return null;
      }

      return /*#__PURE__*/React.createElement("span", {
        style: {
          width: '100%',
          textAlign: 'center',
          display: 'block'
        }
      }, /*#__PURE__*/React.createElement(Link, {
        style: {
          color: '#ccc',
          textDecoration: 'none'
        },
        to: "/assignments/"
      }, this.props.translate('show-all')));
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;

      var _this$props = this.props,
          groupid = _this$props.groupid,
          planid = _this$props.planid,
          translate = _this$props.translate;
      var assignmentFormParams = {
        enableOverlayWarningClose: this.enableOverlayWarningClose,
        overlayWarningPromptAgree: this.overlayWarningPromptAgree,
        overlayWarningPromptClose: this.overlayWarningPromptClose,
        overlayWarningPrompt: this.state.overlayWarningPrompt,
        enableOverlayWarning: this.state.enableOverlayWarning,
        onAbort: this.toggleSingleAssignmentForm,
        editView: false,
        cloneView: false,
        groupid: groupid,
        planid: planid
      };
      return /*#__PURE__*/React.createElement("div", {
        className: "my_tasks"
      }, /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.singleAssignmentFormModal,
        onClose: this.toggleSingleAssignmentForm,
        title: /*#__PURE__*/React.createElement("span", null, translate('create-group-assignment'), ' ', this.state.groupSelected.length > 0 ? " ".concat(translate('for'), " ").concat(this.state.groupSelected) : null)
      }, /*#__PURE__*/React.createElement(AssignmentForm, _extends({}, assignmentFormParams, {
        groupid: this.state.sectionId != null ? this.state.sectionId : this.props.groupid,
        planid: this.props.planid,
        editView: false,
        displayTitle: this.handleGroupDisplay
      }))), !this.state.loadingGroups ? /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.multipleAssignmentFormModal,
        onClose: function onClose() {
          _this7.toggleMultipleAssignmentForm(false);
        },
        title: /*#__PURE__*/React.createElement("span", null, translate('task-create-button'), ' ', this.state.groupSelected.length > 0 ? " ".concat(translate('for'), " ").concat(this.state.groupSelected) : null)
      }, /*#__PURE__*/React.createElement(MultipleAssignmentForm, {
        displayTitle: this.handleGroupDisplay,
        onAbort: this.toggleMultipleAssignmentForm,
        section: this.props.activeSection
      })) : null, this.props.group != null ? /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.groupForm,
        onClose: this.toggleGroupSettings,
        title: this.props.group.title
      }, /*#__PURE__*/React.createElement(SectionForm, {
        onAbort: this.toggleGroupSettings,
        editView: true,
        section: this.props.group
      })) : null, /*#__PURE__*/React.createElement("div", {
        className: "section",
        style: {
          margin: 0,
          padding: 0,
          border: 0
        }
      }, /*#__PURE__*/React.createElement(SectionTitle, null, (this.props.groupid != null || this.state.sectionId != null || this.props.overview) && !this.props.disableTitle ? /*#__PURE__*/React.createElement(Icon, {
        name: "Assignments"
      }) : null, (this.props.groupid != null || this.state.sectionId != null || this.props.overview) && !this.props.disableTitle ? /*#__PURE__*/React.createElement("span", null, this.props.translate('tasks-header-overview')) : null, this.props.overview ? this.CreateButton() : null, this.props.limit && !this.state.loading && !this.state.noSectionFound ? /*#__PURE__*/React.createElement(Link, {
        to: "assignments",
        className: "see-more"
      }, this.props.translate('show-all')) : null)), /*#__PURE__*/React.createElement("div", null, this.renderContent()));
    }
  }]);

  return MyAssignments;
}(Component);

function mapStateToProps(state) {
  return {
    submitted: state.assignments.submitted,
    closed: state.assignments.closed,
    drafts: state.assignments.drafts,
    locked: state.assignments.locked,
    overdue: state.assignments.overdue,
    upcoming: state.assignments.upcoming,
    current: state.assignments.current,
    assignments: state.assignments.assignments,
    teamsAssignments: state.assignments.teamsAssignments,
    services: state.Services.availableServices,
    haldorAssignmentsFetchedUTC: state.assignments.haldorAssignmentsFetchedUTC,
    teamsAssignmentsFetchedUTC: state.assignments.teamsAssignmentsFetchedUTC,
    sections: state.sections.educationGroups,
    currentUser: state.user.currentUser,
    translate: translate(state.Languages.translations),
    group: state.sections.graphSection,
    activeSection: state.sections.activeSection,
    activeGroupForSection: state.assignments.activeGroup,
    createdAssignments: state.assignments.newAssignments
  };
}

export default connect(mapStateToProps, {
  getHaldorAssignments: getHaldorAssignments,
  getSection: getSection,
  setActiveSection: setActiveSection,
  getEducationGroups: getEducationGroups,
  clearAssignmentsFromStore: clearAssignmentsFromStore,
  setPageTitle: setPageTitle,
  setPageActions: setPageActions,
  getMicrosoftEducationAssignments: getMicrosoftEducationAssignments,
  setAssignmentServices: setAssignmentServices,
  getSectionByGraphId: getSectionByGraphId,
  getAssignmentStatus: getAssignmentStatus,
  setMyAssignmentsActiveGroup: setMyAssignmentsActiveGroup,
  updateBulkAssignmentObject: updateBulkAssignmentObject
})(MyAssignments);